export const SET_VIEW = 'SET_VIEW'
export const SET_PAGE_VIEW = 'SET_PAGE_VIEW'
export const SET_PRINT_CAPTURES = 'SET_PRINT_CAPTURES'
export const SET_CAPTURE_SELECTION = 'SET_CAPTURE_SELECTION'
export const SET_CAPTURE_SELECTIONS = 'SET_CAPTURE_SELECTIONS'
export const SET_SELECTED_VIOLATION_ID = 'SET_SELECTED_VIOLATION_ID'
export const SET_SELECTED_VIOLATION_KEY_NUMBER = 'SET_SELECTED_VIOLATION_KEY_NUMBER'
export const SET_CAPTURES_RENDERED = 'SET_CAPTURES_RENDERED'
export const SET_REPORT = 'SET_REPORT'

export const SET_SCROLL_STATUS = 'SET_SCROLL_STATUS'
export const SET_CAPTURE_MODAL_STATUS = 'SET_CAPTURE_MODAL_STATUS'
export const SET_SETTINGS_MODAL_STATUS = 'SET_SETTINGS_MODAL_STATUS'
export const SET_REPORTS_MODAL_STATUS = 'SET_REPORTS_MODAL_STATUS'
export const SET_FILTER_MODAL_STATUS = 'SET_FILTER_MODAL_STATUS'
export const SET_PRINTER_MODAL_STATUS = 'SET_PRINTER_MODAL_STATUS'
export const SET_EXPORT_MODAL_STATUS = 'SET_EXPORT_MODAL_STATUS'
export const SET_SHARE_MODAL_STATUS = 'SET_SHARE_MODAL_STATUS'
export const SET_SEARCH_MODAL_STATUS = 'SET_SEARCH_MODAL_STATUS'

export const SET_FILTER = 'SET_FILTER'
export const SET_PAGE = 'SET_PAGE'
export const SET_PAGE_CAPTURE_LIMIT = 'SET_PAGE_CAPTURE_LIMIT'
export const SET_PAGE_CHANGED = 'SET_PAGE_CHANGED'
export const SET_ALL_CHECKED = 'SET_ALL_CHECKED'
export const SET_PAGE_TYPE = 'SET_PAGE_TYPE'

export const SET_MY_SCHOOLS_STATUS = 'SET_MY_SCHOOLS_STATUS'

export const SET_SELECTED_CAPTURES = 'SET_SELECTED_CAPTURES'

export const SET_GROUP_INDEX = 'SET_GROUP_INDEX'
export const SET_STATUS_SNACK = 'SET_STATUS_SNACK'
export const SET_AWAIT_TRIGGER = 'SET_AWAIT_TRIGGER'
export const SET_TRIGGER_FILTER = 'SET_TRIGGER_FILTER'
export const SET_FROM_LINK = 'SET_FROM_LINK'
export const SET_FLAGGED_ONLY = 'SET_FLAGGED_ONLY'
export const RESET_INITIAL_STATE = 'RESET_INITIAL_STATE'
export const SET_DEFAULT_REPORT_SET = 'SET_DEFAULT_REPORT_SET'
export const SET_DEFAULT_PAGE = 'SET_DEFAULT_PAGE'
export const SET_DEFAULT_VIEW = 'SET_DEFAULT_VIEW'
export const SET_DEFAULT_CAPTURE_COUNT = 'SET_DEFAULT_CAPTURE_COUNT'

export const SET_FROM_VIEW = 'SET_FROM_VIEW'

export const SET_CAPTURES_EXHAUSTED = 'SET_CAPTURES_EXHAUSTED'
export const SET_END_OF_LINK = 'SET_END_OF_LINK'
export const SET_NEED_FILTER = 'SET_NEED_FILTER'

export const SET_FROM_URL = 'SET_FROM_URL'

export const SET_TEMPORARY_QUARANTINE_VIEW = 'SET_TEMPORARY_QUARANTINE_VIEW'
